if (!customElements.get('product-description-expand')) {
  customElements.define(
    'product-description-expand',
    class ProductDescriptionExpand extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-product-description-content]');
        this.toggle = this.querySelector('[data-product-description-toggle]');
        if (!this.content || !this.toggle) return;

        this.updateState();
        this.toggle.addEventListener('click', () => {
          const expanded = this.content.classList.toggle('is-expanded');
          this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          this.toggle.querySelector('.product__description-toggle-more')?.classList.toggle('hidden', expanded);
          this.toggle.querySelector('.product__description-toggle-less')?.classList.toggle('hidden', !expanded);
        });
      }

      updateState() {
        const needsToggle = this.content.scrollHeight > this.content.clientHeight + 8;
        this.classList.toggle('product__description-expand--needs-toggle', needsToggle);
        this.toggle?.classList.toggle('hidden', !needsToggle);
      }
    }
  );
}
